import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2","key":"svg-0"}],["path",{"d":"M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2","key":"svg-1"}],["path",{"d":"M16 12h-8","key":"svg-2"}]]

const IconSpacingVertical = createReactComponent('outline', 'spacing-vertical', 'SpacingVertical', __iconNode);

export default IconSpacingVertical;